import React from 'react';
import { FormattedMessage } from 'react-intl';
import { KnovioLabel } from '../../../../../../../api/connections.dao';

export const MAX_SPEAKER_BIOGRAPHY_LENGTH = 5120;
export const SYNC_SPEAKERS_ERROR_MESSAGE = `Sync of Speakers to ${KnovioLabel.Project} has failed.  Please try again.`;
export const SYNC_SPEAKERS_MAX_BIO_LENGTH_ERROR = 'Maximum biography length is 5120 characters';
export const SYNC_SPEAKERS_SUCCESS_MESSAGE = `Speakers have been successfully sync’ed to ${KnovioLabel.Project}`;
export const SYNC_SPEAKERS_PROFILE_IMAGE_ALT = 'Profile image';

// Formatted Messages
export const SYNC_SPEAKERS_MODAL_TITLE = <FormattedMessage id='oe.syncSpeakersModal.title' defaultMessage='Sync Speakers' />;

export const SYNC_SPEAKERS_MODAL_APPLY_BTN_TITLE = <FormattedMessage id='oe.syncSpeakersModal.apply' defaultMessage='Apply' />;

export const SYNC_SPEAKERS_PENDING_MESAGE = (
    <FormattedMessage
        id='oe.syncSpeakersModal.pendingMessage'
        defaultMessage={`Speakers are being sync to ${KnovioLabel.Project}{suffix}`}
        values={{suffix: '...'}}
    />
);

export const SYNC_SPEAKERS_MODAL_BODY_TITLE = (
    <FormattedMessage
        id='oe.syncSpeakersModal.bodyTitle'
        defaultMessage={`Clicking apply will override the ${KnovioLabel.Project} speaker settings and display this list in the player.`}
    />
);

export const SYNC_SPEAKERS_VIEW_BIO_BTN_TEXT = (
    <FormattedMessage
        id='oe.syncSpeakersModal.viewBio'
        defaultMessage='View Bio +'
    />
);

export const SYNC_SPEAKERS_HIDE_BIO_BTN_TEXT = (
    <FormattedMessage
        id='oe.syncSpeakersModal.hideBio'
        defaultMessage='Hide Bio -'
    />
);